"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable quotes, indent */
var _default = {
  "inputForm.instruction": "オプションとマークされていない限り、すべてのフィールドが必須です",
  "inputField.label.firstName": "名前",
  "inputField.label.lastName": "苗字",
  "inputField.label.fullName": "クレジットカード名義人",
  "inputField.label.Email": "メール",
  "inputField.label.phoneNumber": "電話番号",
  "inputField.placeholder.firstName": "John",
  "inputField.placeholder.lastName": "Doe",
  "inputField.placeholder.fullName": "John Doe",
  "inputField.errorMessage.pleaseEnterAValidFirstName": "有効な名を入力してください",
  "inputField.errorMessage.pleaseEnterAValidLastName": "有効な姓を入力してください",
  "inputField.errorMessage.pleaseEnterAValidFullName": "有効な氏名を入力してください",
  "inputField.errorMessage.invalidAddressValue": "有効な住所を入力してください",
  "inputField.errorMessage.invalidCityValue": "有効な都市を入力してください",
  "inputField.placeholder.email": "john.doe@cashstar.com",
  "inputField.placeholder.phoneNumber": "電話番号を入力",
  "inputField.errorMessage.incompleteField": "不完全なフィールド",
  "inputField.errorMessage.exceedsMaxCharacters": "{max}文字を超過",
  "inputField.errorMessage.pleaseEnterAValidEmailAddress": "正しいメールアドレスを入力してください",
  "inputField.errorMessage.pleaseEnterAValidPhoneNumber": "正しい電話番号を入力してください",
  "inputField.errorMessage.invalidName": "有効な名前を入力してください",
  "header.text.billingInfo": "ご請求情報",
  "submitButton.adyen.label": "支払いをする",
  "inputField.label.cardNumber": "クレジットカード番号",
  "inputField.label.cardExpiry": "有効期限 (MM/YY)",
  "inputField.label.cardCVV": "セキュリティコード",
  "inputField.placeholder.cardNumber": "クレジットカード番号",
  "inputField.placeholder.cardExpiry": "MM/YY",
  "inputField.placeholder.cardCVV": "3桁もしくは4桁のセキュリティコード",
  "inputField.errorMessage.invalidCardNumber": "正しい情報を入力してください",
  "inputField.errorMessage.invalidCardExpiry": "正しい情報を入力してください",
  "inputField.errorMessage.invalidCardCVV": "正しいCVV/CVCを入力してください",
  "inputField.label.country": "国",
  "inputField.label.zipcode": "郵便番号",
  "inputField.label.addressLine": "住所欄",
  "inputField.label.addressLineTwo": "住所行 2 オプション",
  "inputField.label.city": "市区町村",
  "inputField.label.state": "都道府県",
  "inputField.placeholder.zipCode": "郵便番号",
  "inputField.placeholder.addressLine": "住所欄",
  "inputField.placeholder.addressLineTwo": "住所行 2 オプション",
  "inputField.placeholder.city": "市区町村",
  "inputField.placeholder.state": "都道府県",
  "paymentMethod.paypal.login.initial": "PayPal 経由でチェックアウトを完了するには、ログインして支払いの詳細を確認してください",
  "paymentMethod.paypal.login.success": "検証に成功しました。チェックアウトを完了してください",
  "paymentMethod.adyen.label": "クレジットカードと電子バンキング",
  "paymentMethod.adyen.single.label": "クレジットカード",
  "paymentMethod.paypal.label": "PayPal",
  "paymentMethod.zippay.label": "Zip",
  "paymentMethod.zipPay.minCartAmount": "Zip を使用する最小注文額は $35 です",
  "paymentMethod.zipPay.additionalCharges": "Zip の使用には、{amount} ドルの加盟店手数料がかかる場合があります",
  "paymentMethod.creditCard.label": "クレジットカード情報",
  "paymentMethod.googlePay.label": "Google Pay",
  "paymentMethod.applePay.label": "Apple Pay",
  "inputField.label.saveCardLabel": "後で見るように保存",
  "inputField.label.makeAsDefaultLabel": "デフォルトとしてマーク",
  "inputField.errorMessage.cardTypeNotSupported": "カードの種類はサポートされていません"
};
exports.default = _default;